import { post } from '@rails/request.js';

let token = null;

function resetToken() {
  token = null;
}

function tokenURL() {
  const meta = document.querySelector('meta[name="paseto-token-url"]');

  if (!meta) throw new Error('Missing paseto-token-url meta tag');

  return meta.content;
}

async function requestToken() {
  const response = await post(tokenURL(), { responseKind: 'json' });

  if (!response.ok)
    throw new Error(`Token request failed with HTTP ${response.statusCode}`);

  const { token } = await response.json;

  if (!token) throw new Error('Token request returned no token');

  return token;
}

async function vendToken() {
  // Holding the promise rather than the token is what lets callers arriving
  // while one is in flight share it instead of asking for a new one.
  token ||= requestToken();

  try {
    return await token;
  } catch (error) {
    resetToken();
    throw error;
  }
}

async function request(url, { headers, ...options }) {
  const token = await vendToken();
  const requestURL = new URL(url, window.location.href);

  return globalThis.fetch(requestURL, {
    ...options,
    headers: { ...headers, Authorization: `Bearer ${token}` },
  });
}

export async function fetch(url, options = {}) {
  let response = await request(url, options);

  // A token can expire between vending and use. Vend once more before giving
  // up, so a slow page does not fail.
  if (response.status === 401) {
    resetToken();
    response = await request(url, options);
  }

  return response;
}
